import React from 'react'
import { useTranslation } from 'translations'
import { PermissionToggle } from '../components/permissionToggle'
import { Section } from '../components/section'
import { Permission, UserRole } from 'settings/schema'

interface ProductPermissionsSectionProps {
    userRole: UserRole
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const ProductPermissionsSection = ({
    userRole,
    isAdminGranted,
    handlePermissionClick,
}: ProductPermissionsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section title={t('settings.users.form.sections.products')} className="product-permissions">
            <div className="row">
                <PermissionToggle
                    permission="access_products"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted || userRole === 'reseller'}
                />
                <PermissionToggle
                    permission="view_pricing_settings"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
                {userRole !== 'reseller' && (
                    <PermissionToggle
                        permission="edit_pricing_settings"
                        handleClick={handlePermissionClick}
                        disabled={isAdminGranted}
                    />
                )}
            </div>
            {userRole !== 'reseller' && (
                <div className="row">
                    <PermissionToggle
                        permission="view_product_validity"
                        handleClick={handlePermissionClick}
                        disabled={isAdminGranted}
                    />
                    <PermissionToggle
                        permission="edit_product_validity"
                        handleClick={handlePermissionClick}
                        disabled={isAdminGranted}
                    />
                </div>
            )}
        </Section>
    )
}
